import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import BlankLink from '../../../../common/BlankLink';
import InlineInput from '../InlineInput';

const LowFlowFaucets = ({
  t,
  isMetric,
  widgetSource,
  locale,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('On average, we collectively use our faucets')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_low_flow_faucets_avg_daily_use'}
        />
        {t('times a day.')}
      </p>
      <p>
        {t('Of my household\'s')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_low_flow_faucets_amount'}
        />
        {t('faucets, I will replace')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_low_flow_faucets_replaced'}
        />
        {t('of them with more efficient, low-flow faucets. They will each cost')}
        <InlineInput
          currency
          maxLength={6}
          apiKey={'input_takeaction_low_flow_faucets_cost'}
        />.
      </p>
    </div>
    {widgetSource === 'ontario' && <div className="action-details__links">
      <p>
        {t('You can benefit from a free program that helps low-income customers reduce their energy use at home, with a free energy assessment and upgrades. Energy saving devices such as low-flow shower heads and faucet aerators will be installed free of charge. To learn more about this program, check out the')}
        &nbsp;
        <BlankLink href={`https://${t('greenon.ca/')}`} text={t('Green Ontario Fund Website')} />.
      </p>
      <p>
        {t('If you live in a First Nations Community, you are eligible to receive free energy-efficient upgrades for products designed to add comfort and increase efficiency. This includes items such as LED light bulbs, faucet aerators and low-flow shower heads. To learn more about this program, check out the')}
        &nbsp;
        <i><BlankLink href="https://www.hydroone.com/about/indigenous-relations/conservation-program" text={t('First Nations Conservation Program by Save on Energy')} /></i>
        {locale === 'fr' && ' (programme d’économie d’énergie pour les Premières Nations) de Hydro One.'}
        {locale !== 'fr' && '.'}
      </p>
    </div>}
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('On average, we assume that a faucet is used for:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_low_flow_faucets_minutes"
          />
          {t('minutes per use.')}
        </li>
        <li>
          {t('We assume that the conventional faucets use:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_low_flow_faucets_conventional"
          />
          {t('{{volumeUnits}} per minute while the new low-flow faucets use', {
            volumeUnits: isMetric ? t('liters', { ns: 'units' }) : t('gallons', { ns: 'units' }),
          })}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_low_flow_faucets_efficient"
          />
          {t('{{volumeUnits}} per minute.', {
            volumeUnits: isMetric ? t('liters', { ns: 'units' }) : t('gallons', { ns: 'units' }),
          })}
        </li>
      </ul>
    </div>
  </div>
);

LowFlowFaucets.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  widgetSource: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'widgetSource',
  'locale',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('lowFlowFaucets'),
  connect(mapStateToProps, mapDispatchToProps)(LowFlowFaucets),
);
